import { render, staticRenderFns } from "./KnowledgePage.vue?vue&type=template&id=16389266"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePage.vue?vue&type=style&index=0&id=16389266&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports